import React from "react";

const SettingSectionWrapper = ({ children, className = "" }) => {
  return <div className={`p-5 ${className}`}>{children}</div>;
};

export default SettingSectionWrapper;
